import { t } from '@/lib/i18n';

type ScreenLoadingFallbackProps = {
  message?: string;
  inline?: boolean;
};

export function ScreenLoadingFallback({
  message,
  inline = false,
}: ScreenLoadingFallbackProps) {
  return (
    <div
      className={
        inline
          ? 'flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400'
          : 'min-h-[180px] flex items-center justify-center p-6 text-sm text-gray-500 dark:text-gray-400'
      }
    >
      <span className="inline-block h-2 w-2 rounded-full bg-gray-400 animate-pulse" />
      <span>{message || t('ui.loading.default', 'Carregando...')}</span>
    </div>
  );
}

type ScreenErrorFallbackProps = {
  title?: string;
  message: string;
  retryLabel?: string;
  onRetry?: () => void;
};

export function ScreenErrorFallback({
  title,
  message,
  retryLabel,
  onRetry,
}: ScreenErrorFallbackProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 p-6">
      <div className="max-w-lg w-full bg-white dark:bg-gray-800 rounded-xl shadow p-6">
        <h1 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-2">
          {title || t('ui.error.title', 'Ocorreu um erro na interface')}
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-300 mb-4 break-words">
          {message}
        </p>
        <button
          type="button"
          onClick={onRetry}
          className="px-4 py-2 rounded-md bg-gray-900 text-white text-sm hover:bg-gray-700"
        >
          {retryLabel || t('ui.error.retry', 'Tentar novamente')}
        </button>
      </div>
    </div>
  );
}

